<template>
  <section class="content">
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body">
            <ul class="nav nav-tabs" style="margin-bottom: 10px;">
              <li role="presentation" :class="{'active': tab == 1}" @click="updateQuery(1)">
                <a>商品</a>
              </li>
              <li role="presentation" :class="{'active': tab == 3}" @click="updateQuery(3)">
                <a>套餐</a>
              </li>
              <li role="presentation" :class="{'active': tab == 10}" @click="updateQuery(10)">
                <a>分類</a>
              </li>
              <li role="presentation" :class="{'active': tab == 99}" @click="updateQuery(99)" v-if="getRoleType !== 10">
                <a>菜單圖示</a>
              </li>
            </ul>
            <div class="row form-inline" v-if="tab === 99">
              <prod-icon-table :imgList="iconList" :tab="99"></prod-icon-table>
            </div>
            <div class="row" v-else>
              <prod-img-table :imgList="imgList" :imgMeta="imgMeta" :tab="tab" :getProductImageList="getProductImageList"></prod-img-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Require needed datatables modules
import ProdImgTable from './Temp/ProdImgTable.vue'
import ProdIconTable from './Temp/ProdIconTable.vue'
import { mapGetters } from 'vuex'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'ProductImage',
  extends: NdExtendHandleMenu,
  components: {
    'prod-img-table': ProdImgTable,
    'prod-icon-table': ProdIconTable
  },
  data () {
    return {
      brandName: '',
      storeName: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      // tab 選擇
      tab: 1,
      imgList: [],
      iconList: [],
      imgMeta: {
        total: 0,
        size: 20
      },
      page: 1
    }
  },
  methods: {
    updateQuery (tab) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: 1,
          tab: tab
        }
      })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    editStores (menuId) {
      this.$router.push('/upSchedule/all/' + menuId)
    },
    clickPage (index) {
      this.tableIndex = index
      this.getProductImageList()
    },
    checkDoubleStore (storeIdList) {
      console.log('checkDoubleStore', storeIdList)
      let newScheduleList = []
      for (let key in storeIdList) {
        newScheduleList.push(storeIdList[key][0])
      }
      this.setGantt(newScheduleList)
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getProductImageList (page, type = null, search = '') {
      var self = this
      if (page) this.page = page
      // 沒有vendorId 做清空
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/list?size=' + this.count + '&type=' + this.tab + '&page=' + this.page
      if (type && search.trim()) {
        // 搜尋
        url = url + (type === 'name' ? '&product_name=' : '&vendor_custom_id=') + search.trim()
      }
      this.getDataH('get', url, null, function (response) {
        self.imgList = response.data.list
        self.imgMeta = response.data.meta
      })
    },
    getProductIconList () {
      var self = this
      // self.bindList = []
      var url = 'store/' + this.$route.params.store_id + '/productIconSetting/list?size=' + this.count + '&page=' + this.page + '&type=1'
      this.getDataH('get', url, null, function (response) {
        self.iconList = response.data.list
      })
    },
    getStoreInfo () {
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const storeInfo = response.data.info
          this.brandName = storeInfo.brand_name
          this.storeName = storeInfo.name
          this.$router.replace(
            {
              query: {
                brand_name: storeInfo.brand_name,
                store_name: storeInfo.name
              }
            },
            ...this.$route.query
          )
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getStores']),
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        })
      }
      return menuList
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    // 顯示 {品牌名稱 - 門市名稱}
    if (!this.$route.query.brand_name || !this.$route.query.store_name) {
      this.getStoreInfo()
    } else {
      this.brandName = this.$route.query.brand_name
      this.storeName = this.$route.query.store_name
    }
  },
  watch: {
    tab () {
      this.page = Number(this.$route.query.page) || 1
      if (this.tab !== 99) this.getProductImageList(this.page)
      else this.getProductIconList()
    },
    '$route.query.tab' () {
      var defaultTab = this.$route.query.tab
      if (defaultTab) this.tab = parseInt(defaultTab, 10)
    }
  },
  mounted () {
    var defaultTab = this.$route.query.tab
    if (defaultTab) this.tab = parseInt(defaultTab, 10)
    this.page = Number(this.$route.query.page) || 1
    if (this.tab !== 99) this.getProductImageList(this.page)
    else this.getProductIconList(this.page)
    this.getExtendHandleMenuInfo()
  }
}
</script>
<style lang="sass">
  .menu-info
    min-height: 120px
    width: 100%
    text-align: center
    *
      padding: 0
      margin: 0
      line-height: 25px
  .m-b-15
    margin-bottom: 15px !important
  .btn-edit-all, .btn-del-all
    margin-right: 15px
    z-index: 100
  .nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
    display: none !important
  .fn-gantt .leftPanel
    width: 100px !important
  .fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
    font-size: 14px
  .fn-gantt .navigate
    padding: 10px 0 10px 10px !important
  @media screen and (max-width: 499px)
    .min-m-t-10
      margin-top: 25px
</style>



// WEBPACK FOOTER //
// ProductImage.vue?4907b11a